<template>
  <div class="stress-management">
    <div class="d-flex justify-space-between">
      <h2 class="mb-8">{{ $ucfirst($t("screens.stressReliefSettingsScreen", { catalog: 'app_mobile' })) }}</h2>
      <level-of-guidance-indicator behaviourComponent="STRESSMANAGEMENT"></level-of-guidance-indicator>
    </div>
    <stress-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
        :nextRoutes="nextDiscussionStep"
        :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import LevelOfGuidanceIndicator from "../../../components/Parts/LevelOfGuidanceIndicator.vue";
import StressButtonLine from '../../../components/Parts/StressButtonLine';

export default {
  name: 'PatientOverviewStress',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    StressButtonLine,
    LevelOfGuidanceIndicator,
    DiscussionStepNavButtons
  }
}
</script>
